"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var gotoNext = exports.gotoNext = function (a) {
  var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : null;
  a.startsWith("http") ? window.location.replace(a) : a.startsWith("#") ? b.history.push(a.replace("#", "")) : b.history.push(a);
};